import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';
import { ProductLogoMediumSoftware } from '@/components/Logo';
import type { TabWithIndicatorProps } from '@/components/Navigation/HeaderTabs';
import { ProductHeader } from '@/components/ProductHeader';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/software/_layout')({
  component: Layout
});
function Layout() {
  const {
    t
  } = useTranslation();
  useDocumentTitle(t('pages.software.productHeader.pageTitle'));
  const tabs = useMemo(() => {
    const baseTabs: TabWithIndicatorProps[] = [{
      to: '/software',
      children: t('common.list.overview'),
      activeOptions: {
        exact: true
      }
    }, {
      to: '/software/registry',
      children: t('common.list.registry')
    }, {
      to: '/software/people',
      children: t('common.list.people')
    }, {
      to: '/software/alerts',
      children: t('common.list.alerts')
    }, {
      to: '/software/contract-and-cost',
      children: t('common.list.contractAndCost')
    }, {
      to: '/software/operation-activity',
      children: t('common.list.operationActivity')
    }, {
      to: '/software/library',
      children: t('common.list.library')
    }, {
      to: '/software/rule-and-policy',
      children: t('common.list.ruleAndPolicy')
    }, {
      to: '/software/settings',
      children: t('common.list.settings')
    }];
    return baseTabs;
  }, [t]);
  return <div className="flex h-full flex-col">
      <ProductHeader Logo={ProductLogoMediumSoftware} name={t('pages.software.productHeader.pageTitle')} tabs={tabs} type="resource" />
      <div className="relative min-h-0 flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>;
}